export default "__VITE_ASSET__8704a2e5__"